import React, { useEffect } from "react";
import { Navbar } from "./components/Navbar";
import { HeroBanner } from "./components/HeroBanner";
import { Speakers } from "./components/SpeakerCard";
import { Agenda } from "./components/Agenda";
import { Highlights } from "./components/Highlights";
import { CtaSection } from "./components/CtaSection";
import Footer from "../NewLandingPage/components/Footer";
import { Helmet } from "react-helmet";
import { navigate, useLocation } from "@reach/router";
import useWebinar from "../../../hooks/useWebinar";
import ModernSpinner from "./components/ModernSpinner";
import { Header } from "../../internal/Header/Header";
import SystemService from "../../../services/SystemService";

const REDIRECT_MAP = {
  odr: "#odr",
  transcription: "#transcription",
  "case-management": "#case-management",
  "our-offerings": "#our-offerings",
  "enquire-now": "#enquire-now",
  home: "#home",
};

export default function PastWebinarDetails({ id }) {
  const location = useLocation();

  const { config, loading, setConfig, setLoading } = useWebinar();

  useEffect(() => {
    const prefetchUpcoming = async () => {
      try {
        setLoading(true);
        if (id) {
          const res = await SystemService.fetchWebinarConfigById(id);
          const data = res?.data || {};
          setConfig(data);
        }
      } catch (err) {
        setConfig({ message: err?.message || "Failed to load" });
      } finally {
        setLoading(false);
      }
    };

    prefetchUpcoming();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const { pathname, hash } = location;
    if (pathname.includes("/upcoming_webinars/")) {
      if (hash === "#about-us") {
        navigate("/about-us", { replace: true });
        return;
      }
      if (hash === "#terms-and-conditions") {
        navigate("/terms-and-conditions", { replace: true });
        return;
      }
      if (hash === "#privacy-policy") {
        navigate("/privacy-policy", { replace: true });
        return;
      }
    }
    if (hash) {
      const key = Object.keys(REDIRECT_MAP).find((k) => hash.includes(k));
      if (key) navigate(`/${REDIRECT_MAP[key]}`, { replace: true });
    }
  }, [location.pathname, location.hash]); // eslint-disable-line react-hooks/exhaustive-deps

  if (config?.message) {
    return (
      <>
        <Header>
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "openSans-Regular, sans-serif",
              color: "#293461",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>
                Webinar Not Found
              </h2>
              <p style={{ color: "#949ab0" }}>
                The requested webinar does not exist.
              </p>
            </div>
          </div>
        </Header>
        <Footer top={false} />
      </>
    );
  }

  const isEmpty = !config || Object.keys(config).length === 0;
  if (loading || isEmpty) return <ModernSpinner />;

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Webinar - {config?.slug || ""}</title>
        <meta name="description" content={config?.slug || ""} />
        <meta name="keywords" content={config?.slug || ""} />
      </Helmet>

      {config?.navbar?.show && <Navbar data={config.navbar} />}
      {config?.hero && <HeroBanner data={config.hero} />}
      {config?.speakers?.show && <Speakers data={config.speakers} />}
      {config?.agenda?.show && <Agenda data={config.agenda} />}
      {config?.highlights?.show && <Highlights data={config.highlights} />}
      {config?.cta?.show && <CtaSection data={config.cta} />}

      <Footer data={config.footer} top={false} />
    </>
  );
}
